// client/src/services/zoneService.js
import axios from '../utils/axiosConfig';

export const listZones = () => axios.get('/zones').then(r => r.data.zones);
export const checkZoneCoverage = (zoneId) =>
  axios.get(`/zones/${zoneId}/coverage`).then(r => r.data);
// Therapist-only: adds a zone (or returns the existing one if it already exists).
export const addZone = (data) => axios.post('/zones', data).then(r => r.data.zone);
